class HeaderNav extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.handleOnMouseEnter = this.handleOnMouseEnter.bind(this)
    this.handleOnMouseLeave = this.handleOnMouseLeave.bind(this)
    this.checkIfScrolled = this.checkIfScrolled.bind(this)
    this.handleOnScroll = this.handleOnScroll.bind(this)

    if (window.BAO.MediaBreakpoints.isMd) {
      this.listeners.add(this, 'mouseenter', this.handleOnMouseEnter)

      this.listeners.add(
        this.externalEls.menu.element,
        'mouseleave',
        this.handleOnMouseLeave,
      )
    }

    this.listeners.add(window, 'load', this.checkIfScrolled)

    this.listeners.add(window, 'scroll', this.handleOnScroll, {
      passive: true,
    })
  }

  checkIfScrolled () {
    if (window.scrollY > 0) {
      this.externalEls.container.element.classList.add('hd-Banner-scrolled')
    } else {
      this.externalEls.container.element.classList.remove('hd-Banner-scrolled')
    }
  }

  handleOnScroll () {
    this.externalEls.container.element.classList.remove('hd-Banner-scrolled')
    this.externalEls.container.element.classList.add('hd-Banner-scrolling')

    clearTimeout(this.scrollTimeout)
    this.scrollTimeout = setTimeout(() => {
      if (window.scrollY > 0) {
        this.externalEls.container.element.classList.add('hd-Banner-scrolled')
      } else {
        this.externalEls.container.element.classList.remove(
          'hd-Banner-scrolled',
        )
      }
    }, 250)
  }

  handleOnMouseEnter () {
    this?.els?.trigger?.element.click()
  }

  handleOnMouseLeave () {
    if (
      document.activeElement.classList.contains('nls-NewsletterSignup_Input')
    ) {
      // Fixes bug where inputting text into the email field would randomly trigger the mouseleave event
      return
    }

    const triggerEl = this?.els?.trigger?.element
    if (!triggerEl) return

    const key = triggerEl.getAttribute('data-drawers-trigger')
    if (key && !document.body.classList.contains(`drw-Drawers-${key}`)) return

    this?.els?.trigger?.element.click()
  }

  closeMenu () {
    const triggerEl = this?.els?.trigger?.element
    if (!triggerEl) return

    const key = triggerEl.getAttribute('data-drawers-trigger')
    if (key && !document.body.classList.contains(`drw-Drawers-${key}`)) return

    this?.els?.trigger?.element.click()
  }
}

if (!customElements.get('header-nav')) {
  customElements.define('header-nav', HeaderNav)
}
